import { Link } from 'react-router-dom';
import React from 'react';
import { Card } from 'react-bootstrap';
import { ChevronRight } from 'lucide-react';

const CardsPods = ({
  CardLabel,
  teamLeadName,
  membersCount,
  PageRoute,
  CardColor = 'bg-brand-light'
}) => {
  const getInitials = (name) => {
    if (!name) return '';
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  return (
    <Card className={`border-0 rounded-12 ${CardColor} card-managers`}>
      <Card.Body className="p-16">
        <div className="d-flex align-items-center mb-16 header">
          <span className="mask-icon w-h-16 me-7 mask-teams" aria-hidden="true"></span>
          <h6 className="text-16 fw-700 text-navy mb-0">{CardLabel}</h6>
        </div>

        <div className="mb-24">
          {teamLeadName && (
            <div className="d-flex align-items-center contact-item mb-10">
              <img src="/assets/icons/managers.svg" alt="Team Lead" className="me-6" width="14" height="14" />
              <span className="text-14 fw-500 text-navy">{teamLeadName}</span>
            </div>
          )}

          {typeof membersCount !== 'undefined' && (
            <div className="d-flex align-items-center contact-item">
              <span className="mask-icon w-h-14 me-6 mask-teammember" aria-hidden="true"></span>
              <span className="text-14 fw-500 text-navy">Team Members: {membersCount?.toString().padStart(2, '0')}</span>
            </div>
          )}
        </div>

        <Link to={PageRoute} className="text-decoration-none">
          <div className="view-details-btn d-inline-flex align-items-center border border-brand">
            <span className="text-16 fw-700 text-brand">View Details</span>
            <ChevronRight size={16} className="text-brand ms-1" />
          </div>
        </Link>
      </Card.Body>
    </Card>
  );
};

export default CardsPods;
